import LoggingListener from "./ILoggingListener";

export default class LoggingBase {

    private listeners: LoggingListener[] = [];
    private originalConsoleLog: (msg: string) => void = null;

    constructor(...listeners: LoggingListener[]) {
        listeners.forEach(this.addListener);
        this.originalConsoleLog = console.log;
        console.log = (msg: string) => {
            this.logMessage(msg, true);
        }
    }

    public addListener = (listener: LoggingListener) => {
        this.listeners.push(listener);
    }

    public logMessage = (message: string, indirectCall: boolean = false) => {
        // this.originalConsoleLog((new Error()).stack);
        // const line = (new Error()).stack.split("\n")[indirectCall ? 3 : 2].trim().split(" ")[1];
        // const lineFinal = (line.indexOf(' (') >= 0
        //         ? line.split(' (')[1].substring(0, line.length - 1)
        //         : line.split('at ')[1]
        // );
        this.listeners.forEach(listener => {listener.logMessage(message)})
    }

}


// WEBPACK FOOTER //
// ./src/logging/LoggingBase.ts